/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Bwf_Title_LabelInputs */

const en_audio_description_export_bwf_title_label = /** @type {(inputs: Audio_Description_Export_Bwf_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const fr_audio_description_export_bwf_title_label = /** @type {(inputs: Audio_Description_Export_Bwf_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre`)
};

const de_audio_description_export_bwf_title_label = /** @type {(inputs: Audio_Description_Export_Bwf_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

const it_audio_description_export_bwf_title_label = /** @type {(inputs: Audio_Description_Export_Bwf_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo`)
};

const ru_audio_description_export_bwf_title_label = /** @type {(inputs: Audio_Description_Export_Bwf_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заголовок`)
};

const es_audio_description_export_bwf_title_label = /** @type {(inputs: Audio_Description_Export_Bwf_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

const zh_cn2_audio_description_export_bwf_title_label = /** @type {(inputs: Audio_Description_Export_Bwf_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题`)
};

const ja_audio_description_export_bwf_title_label = /** @type {(inputs: Audio_Description_Export_Bwf_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトル`)
};

const hi_audio_description_export_bwf_title_label = /** @type {(inputs: Audio_Description_Export_Bwf_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षक`)
};

const pt_pt2_audio_description_export_bwf_title_label = /** @type {(inputs: Audio_Description_Export_Bwf_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Audio_Description_Export_Bwf_Title_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_bwf_title_label = /** @type {((inputs?: Audio_Description_Export_Bwf_Title_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Bwf_Title_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_bwf_title_label(inputs)
	if (locale === "de") return de_audio_description_export_bwf_title_label(inputs)
	if (locale === "it") return it_audio_description_export_bwf_title_label(inputs)
	if (locale === "ru") return ru_audio_description_export_bwf_title_label(inputs)
	if (locale === "es") return es_audio_description_export_bwf_title_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_bwf_title_label(inputs)
	if (locale === "ja") return ja_audio_description_export_bwf_title_label(inputs)
	if (locale === "hi") return hi_audio_description_export_bwf_title_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_bwf_title_label(inputs)
	return en_audio_description_export_bwf_title_label(inputs)
});